import React from 'react'
import { OutlinedInput, InputLabel, FormControl, Select, MenuItem } from '@mui/material/'
export default function SelectRelationship({ setRelationship, relationship, disabled }) {
    return (
        <FormControl fullWidth>
            <InputLabel id="relationLabel">Select Relationship*</InputLabel>
            <Select
                labelId="relationLabel"
                id="relationship"
                value={relationship}
                label="Select Relationship*"
                onChange={(e) => setRelationship(e.target.value)}
                required
                disabled={disabled}
            >

                <MenuItem key="Mother" value="Mother">Mother</MenuItem>
                <MenuItem key="Father" value="Father">Father</MenuItem>
                <MenuItem key="Step Mother" value="Step Mother">Step Mother</MenuItem>
                <MenuItem key="Step Father" value="Step Father">Step Father</MenuItem>
                <MenuItem key="Grandmother" value="Grandmother">Grandmother</MenuItem>
                <MenuItem key="Grandfather" value="Grandfather">Grandfather</MenuItem>
                <MenuItem key="Sister" value="Sister">Sister</MenuItem>
                <MenuItem key="Brother" value="Brother">Brother</MenuItem>
                <MenuItem key="Aunt" value="Aunt">Aunt</MenuItem>
                <MenuItem key="Uncle" value="Uncle">Uncle.</MenuItem>
                <MenuItem key="Cousin" value="Cousin">Cousin</MenuItem>
                <MenuItem key="Caregiver " value="Caregiver">Caregiver</MenuItem>
                <MenuItem key="Embasy Contact" value="Embasy Contact">Embasy Contact</MenuItem>
                <MenuItem key="Corporate Sponsor" value="Corporate Sponsor">Corporate Sponsor</MenuItem>
                <MenuItem key="Other " value="Other">Other</MenuItem>

            </Select>
        </FormControl>
    )
}
